import {gsap, SplitText, ScrollTrigger} from "../LibrariesImport";
export default class Section {
	static init() {

		this.sections = document.querySelectorAll('.page-container > .section, .page-container > .pin-spacer > .section:not(.section-color-transparent)');

		this.sections.forEach((section) => {

			let props = window.getComputedStyle(section);
			let backgroundColor = props.getPropertyValue("background-color");

			gsap.set(section, {
				backgroundColor: "#ffffff"
			});

			gsap.to(section, {
				backgroundColor: backgroundColor,
				scrollTrigger: {
					trigger: section,
					start: "top bottom",
					end: "top center",
					scrub: 1
				}
			});

		});

	}
}